import { Button, Div, Text } from "atomize"
import { theme } from "../settings/config"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPen, faRotateLeft, faTrashAlt } from "@fortawesome/free-solid-svg-icons"
import { faClone } from "@fortawesome/free-regular-svg-icons"
import { useContext } from "react"
import { modalContext } from "../providers/modal.provider"
import { sharedDataContext } from "../providers/sharedData.provider"
import { getLessonColor } from "../utils/func.utils"
import { isCancelledLesson } from "../utils/cancellation.utils"

// Tre bottoni nel colore cupo della lezione. Quello che ci sta sopra è
// `surface` e non il bianco: nel chiaro è lo stesso bianco di sempre, nello
// scuro segue il fondo, perché lì il colore cupo diventa il pastello.
// `m` è lo spazio intorno: la scheda di una lezione ne vuole di più della
// riga compatta di "Gioco io", che usa gli stessi bottoni.
const DEFAULT_MARGIN = { t: "1.5rem", x: "1rem" }

function LessonActions({ lessonData, canEdit, m = DEFAULT_MARGIN }) {
	const Modal = useContext(modalContext)
	const { getLessonType } = useContext(sharedDataContext)

	if (!canEdit) return null

	// Una lezione annullata non si modifica né si duplica: si ripristina, o
	// si elimina se non doveva esserci.
	if (isCancelledLesson(lessonData))
		return (
			<Div m={m} d="flex" justify="end" align="center">
				<Button
					p={{ x: "1rem" }}
					bg={getLessonColor(getLessonType(lessonData.lessonType), true)}
					rounded={theme.rounded["20px"]}
					aria-label="Elimina"
					onClick={() => Modal.open("deleteLesson", lessonData)}>
					<FontAwesomeIcon icon={faTrashAlt} color={theme.colors.surface} />
				</Button>
				<Button
					m={{ l: "0.5rem" }}
					p={{ x: "1rem" }}
					bg={getLessonColor(getLessonType(lessonData.lessonType), true)}
					rounded={theme.rounded["20px"]}
					style={{ gap: "0.25rem" }}
					onClick={() => Modal.open("restoreLesson", lessonData)}>
					<FontAwesomeIcon icon={faRotateLeft} color={theme.colors.surface} />
					<Text tag="span" textWeight="bold" textColor={theme.colors.surface}>
						Ripristina
					</Text>
				</Button>
			</Div>
		)

	return (
		<Div m={m} d="flex" justify="end" align="center">
			<Button
				p={{ x: "1rem" }}
				bg={getLessonColor(getLessonType(lessonData.lessonType), true)}
				rounded={theme.rounded["20px"]}
				aria-label="Elimina"
				onClick={() => Modal.open("deleteLesson", lessonData)}>
				<FontAwesomeIcon icon={faTrashAlt} color={theme.colors.surface} />
			</Button>
			<Button
				m={{ x: "0.5rem" }}
				p={{ x: "1rem" }}
				bg={getLessonColor(getLessonType(lessonData.lessonType), true)}
				rounded={theme.rounded["20px"]}
				style={{ gap: "0.25rem" }}
				onClick={() => Modal.open("editLesson", lessonData)}>
				<FontAwesomeIcon icon={faPen} color={theme.colors.surface} />
				<Text tag="span" textWeight="bold" textColor={theme.colors.surface}>
					Modifica
				</Text>
			</Button>
			<Button
				p={{ x: "1rem" }}
				bg={getLessonColor(getLessonType(lessonData.lessonType), true)}
				rounded={theme.rounded["20px"]}
				style={{ gap: "0.25rem" }}
				onClick={() => Modal.open("duplicateLesson", lessonData)}>
				<FontAwesomeIcon icon={faClone} color={theme.colors.surface} />
				<Text tag="span" textWeight="bold" textColor={theme.colors.surface}>
					Duplica
				</Text>
			</Button>
		</Div>
	)
}

export default LessonActions
